function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 16.667C7.2425 16.667 5 14.4245 5 11.667C5 8.90949 7.2425 6.66699 10 6.66699C12.7575 6.66699 15 8.90949 15 11.667C15 14.4245 12.7575 16.667 10 16.667ZM10 7.50033C7.7025 7.50033 5.83333 9.36949 5.83333 11.667C5.83333 13.9645 7.7025 15.8337 10 15.8337C12.2975 15.8337 14.1667 13.9645 14.1667 11.667C14.1667 9.36949 12.2975 7.50033 10 7.50033Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.6673 13.75C11.5607 13.75 11.454 13.7092 11.3723 13.6283L9.70565 11.9617C9.62815 11.8833 9.58398 11.7775 9.58398 11.6667V9.16667C9.58398 8.93667 9.77065 8.75 10.0007 8.75C10.2307 8.75 10.4173 8.93667 10.4173 9.16667V11.4942L11.9623 13.0392C12.1248 13.2017 12.1248 13.4658 11.9623 13.6283C11.8807 13.7092 11.774 13.75 11.6673 13.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9167 19.1663H2.08333C0.934167 19.1663 0 18.2322 0 17.083V2.91634C0 1.76717 0.934167 0.833008 2.08333 0.833008H17.9167C19.0658 0.833008 20 1.76717 20 2.91634V17.083C20 18.2322 19.0658 19.1663 17.9167 19.1663ZM2.08333 1.66634C1.39417 1.66634 0.833333 2.22717 0.833333 2.91634V17.083C0.833333 17.7722 1.39417 18.333 2.08333 18.333H17.9167C18.6058 18.333 19.1667 17.7722 19.1667 17.083V2.91634C19.1667 2.22717 18.6058 1.66634 17.9167 1.66634H2.08333Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.5833 5.00032H0.416667C0.186667 5.00032 0 4.81366 0 4.58366C0 4.35366 0.186667 4.16699 0.416667 4.16699H19.5833C19.8133 4.16699 20 4.35366 20 4.58366C20 4.81366 19.8133 5.00032 19.5833 5.00032Z",
  fill: "currentColor"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "currentColor"
})));

var SvgStep1 = function SvgStep1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step1.26ae29d1.svg";
export { ForwardRef as ReactComponent };